// extracted by mini-css-extract-plugin
module.exports = {"c16lr040":"c16lr040","visually-hidden":"visually-hidden"};